import { useDrawdownRepaymentSchedule } from '@api/lendingAPI/lapiHooks';
import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { getDurationInMonths } from '@helpers/GetDurationInMonths/getDurationInMonths';
import { getMonthlyRepaymentAmount } from '@helpers/RepaymentSchedule/getMonthlyRepaymentAmount';
import { FormattedMessage } from 'react-intl';

import { FormattedCurrency } from '../../../../../../../../iwIntlProvider/FormattedCurrency';

export const DurationLabel = ({
    offer,
    drawdownAmount
}: {
    offer: TFormalOffer;
    drawdownAmount: number;
}) => {
    const { data } = useDrawdownRepaymentSchedule({
        offerId: offer.offer_id!,
        drawdownAmount,
        keepPreviousData: true
    });

    const monthlyRepayment = data ? getMonthlyRepaymentAmount(data) : null;

    return (
        <span>
            <FormattedMessage
                id="_.flexi_approved.duration_option"
                defaultMessage="<bold>{monthlyRepaymentAmount} per month</bold> for up to {months} months"
                values={{
                    monthlyRepaymentAmount:
                        monthlyRepayment !== null ? (
                            <FormattedCurrency value={monthlyRepayment} />
                        ) : (
                            '--,-- €'
                        ),
                    months: getDurationInMonths(offer.duration!),
                    bold: (chunks) => (
                        <span className="font-bold">{chunks}</span>
                    )
                }}
            />
        </span>
    );
};
